import { Navigate } from 'react-router';
import { useAuth } from '@/providers/AuthContext';
import { ROUTES } from '@/shared/constants';
import { Permission } from '@/shared/model/permission';
import { checkUserPermission } from '@/shared/lib/permissions-utils';

interface LoggedInRouteProps {
  children: React.ReactNode;
  authorizedPermissions?: Permission[];
}

const LoggedInRoute = ({
  children,
  authorizedPermissions,
}: LoggedInRouteProps) => {
  const { user, signedIn, invalid, loading } = useAuth();

  if (loading) {
    return <p>loading</p>;
  }

  if (invalid) {
    return <Navigate to={ROUTES.InvalidAccount} />;
  }
  if (!signedIn || !user) return <Navigate to={ROUTES.Login} />;

  if (!authorizedPermissions) {
    return children;
  }

  if (!checkUserPermission(user, authorizedPermissions)) {
    return <Navigate to='/' replace />;
  }

  return children;
};

export default LoggedInRoute;
